import React from 'react';

const GameMapBackground = () => (
  <>
    {/* Grass */}
    <rect width="460" height="560" fill="#5a9e52" />
    {/* Tree clusters — top left */}
    <ellipse cx="20" cy="25" rx="65" ry="50" fill="#2d6a27" fillOpacity="0.85" />
    <ellipse cx="85" cy="10" rx="50" ry="38" fill="#3a7a32" fillOpacity="0.75" />
    {/* Tree clusters — top right */}
    <ellipse cx="430" cy="20" rx="55" ry="45" fill="#2d6a27" fillOpacity="0.85" />
    <ellipse cx="460" cy="55" rx="32" ry="42" fill="#3a7a32" fillOpacity="0.75" />
    {/* Left side trees */}
    <ellipse cx="12" cy="130" rx="32" ry="62" fill="#2d6a27" fillOpacity="0.75" />
    <ellipse cx="18" cy="230" rx="28" ry="55" fill="#3a7a32" fillOpacity="0.7" />
    <ellipse cx="10" cy="315" rx="32" ry="48" fill="#2d6a27" fillOpacity="0.75" />
    {/* Bottom trees */}
    <ellipse cx="55" cy="548" rx="72" ry="32" fill="#2d6a27" fillOpacity="0.85" />
    <ellipse cx="210" cy="558" rx="85" ry="28" fill="#3a7a32" fillOpacity="0.8" />
    <ellipse cx="375" cy="550" rx="82" ry="32" fill="#2d6a27" fillOpacity="0.85" />
    {/* Right edge trees */}
    <ellipse cx="456" cy="210" rx="24" ry="52" fill="#2d6a27" fillOpacity="0.65" />
    <ellipse cx="453" cy="385" rx="26" ry="42" fill="#3a7a32" fillOpacity="0.65" />
    {/* Garden beds */}
    <ellipse cx="368" cy="292" rx="26" ry="20" fill="#6b4c11" fillOpacity="0.45" />
    <ellipse cx="393" cy="308" rx="18" ry="14" fill="#6b4c11" fillOpacity="0.4" />
    {/* House */}
    <polygon points="85,305 355,305 355,430 408,430 408,545 85,545" fill="#8a8a8a" stroke="#666" strokeWidth="1.5" />
    {/* Deck */}
    <rect x="85" y="305" width="180" height="78" fill="#c8a058" />
    {[313,321,329,337,345,353,361,369,377].map(py => (
      <line key={py} x1="85" y1={py} x2="265" y2={py} stroke="#a07838" strokeWidth="1" strokeOpacity="0.65" />
    ))}
    <rect x="265" y="305" width="90" height="78" fill="#8a8a8a" />
    {/* Fireplace */}
    <g style={{ pointerEvents: 'none' }}>
      <circle cx="68" cy="205" r="44" fill="#80706a" />
      <circle cx="68" cy="205" r="37" fill="#56504a" />
      {[0,45,90,135,180,225,270,315].map(deg => {
        const rad = (deg * Math.PI) / 180;
        return <circle key={deg} cx={68 + 40 * Math.sin(rad)} cy={205 - 40 * Math.cos(rad)} r="5" fill="#706050" />;
      })}
      <circle cx="68" cy="205" r="25" fill="#1a0f08" />
      <circle cx="68" cy="210" r="14" fill="#c43c00" fillOpacity="0.9" />
      <ellipse cx="68" cy="199" rx="9" ry="15" fill="#ff7700" fillOpacity="0.92" />
      <ellipse cx="60" cy="204" rx="6" ry="11" fill="#ff5500" fillOpacity="0.85" />
      <ellipse cx="76" cy="204" rx="6" ry="11" fill="#ff5500" fillOpacity="0.85" />
      <ellipse cx="68" cy="195" rx="5" ry="9" fill="#ffbb00" fillOpacity="0.9" />
      <ellipse cx="65" cy="193" rx="3" ry="6" fill="#ffee44" fillOpacity="0.85" />
    </g>
    {/* Patio table */}
    <g style={{ pointerEvents: 'none' }}>
      <rect x="210" y="324" width="16" height="36" rx="2" fill="#c8a870" stroke="#a07840" strokeWidth="1.5" />
      <rect x="234" y="324" width="16" height="36" rx="2" fill="#c8a870" stroke="#a07840" strokeWidth="1.5" />
    </g>
  </>
);

export default GameMapBackground;
